import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { Button, DialogActions, DialogContent, TextField } from "@mui/material";
import PlusIcon from "./../../Assests/plus-icon.svg";
import SelectDataUpload from "./SelectDataUpload";
import {
  createFolder,
  inputFolderValue,
  inputUploadFolderId,
  displayFolderList,
  displayFolderListSuccess,
  displayFolderListError,
  openErrorDialog,
  scenarioaBack,
} from "./../../Redux/Actions/InputData";
import * as actions from "./../../Redux/Actions/InputData";
import CreateFolder from "./CreateFolder";
import { getRequest } from "../../Services/AxiosConfiguration";
import {
  API_BASE_URL,
  CGO_FOLDER_GET_API,
  DISPLAY_FOLDER_LIST_BY_USECASE_AND_USERID_API,
  // DISPLAY_FOLDER_LIST_BY_USECASE_API,
} from "../../Utils/Config";
import CGOInputForm from "./CgoInputForm";
import CGOCreateFolder from "./CGOCreateFolder";
// eslint-disable-next-line react-hooks/rules-of-hooks

function CGOInputModal(props: any) {
  console.log(props, "propppppppppppppppp");
  const dispatch: any = useDispatch();
  const [selectFolder, setSelectFolder] = useState("");
  const filteredFoldersList = useSelector(
    (state: any) => state.InputDataReducers.filteredFoldersList
  );
  const [folderOptions, setFolderOptions] = useState([]);
  const [inputFolderName, setInputFolderName] = useState("");
  const [selectFolderTimePeriod, setSelectFolderTimePeriod] = useState("");
  const [newScenarioValue, setNewScenarioValue] = useState("");
  const [showCGOInputForm, setShowCGOInputForm] = useState(
    props.selectRadio !== "masterData"
  );
  const selectedFolderId = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderId
  );

  const isCreateFolder = useSelector(
    (state: any) => state.InputDataReducers.isCreateFolder
  );

  const { isFolderCreated, folderCreationMessage } = useSelector(
    (state: any) => state.InputDataReducers
  );
  const selectedUsecaseId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId
  );

  const selectedCategoryId = useSelector(
    (state: any) => state.InputDataReducers.selectedCategoryId
  );
  const userData = useSelector(
    (state: any) => state.InputDataReducers.apiUserData
  );
  console.log(userData, "userData");

  useEffect(() => {
    callFolderFilterApi();
  }, []);

  const callFolderFilterApi = async () => {
    dispatch(displayFolderList());
    // const urls = API_BASE_URL + CGO_FOLDER_GET_API;
    const urls = API_BASE_URL + DISPLAY_FOLDER_LIST_BY_USECASE_AND_USERID_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    await getRequest(
      urls,
      { useCase: 4, category: 0, createdBy: userData.userId },
      header
    )
      .then((response) => {
        if (response.status === 200 && response.data) {
          let responseArray = [];
          responseArray.push(response.data?.data);
          const sorted = response.data?.data.sort((a: any, b: any) =>
            a?.folder.localeCompare(b?.folder)
          );
          setFolderOptions(sorted);
          dispatch(displayFolderListSuccess(response.data?.data));
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
        dispatch(displayFolderListError(error.message));
      });
  };
  const [isCreateNewFolder, setIsCreateNewFolder] = useState(false);
  const handleOpenCreateFolder = () => {
    dispatch(createFolder());
    setIsCreateNewFolder(true);
  };

  const handleChangeSelectFolder = (e: any) => {
    setSelectFolder(e.target.value);
    localStorage.setItem("selectedCGOFolderId", e.target.value.id);
    //setSelectedFolderId(e.target.value.id);
    if (e.target.value.id !== undefined) {
      console.log(e.target.value.id, "folderIDDDDD");
      dispatch(inputUploadFolderId(e.target.value.id));
    }
  };

  const handleInputFolderName = (e: any) => {
    setInputFolderName(e.target.value);
    dispatch(inputFolderValue(e.target.value));
    //dispatch(inputUploadFolderId(e.target.value.id));
  };

  const handleSelectTimePeriod = (e: any) => {
    setSelectFolderTimePeriod(e.target.value);
  };

  const handleCreateNewFolder = () => {
    const request = {
      id: 0,
      usecase: selectedUsecaseId,
      category: selectedCategoryId,
      folder: inputFolderName,
      folder_time: 1,
      createdBy: userData.userId,
    };
    if (selectedUsecaseId > 0 && selectedCategoryId > 0) {
      dispatch(actions.onInitCreateNewFolder(request));
    }
    setShowCGOInputForm(true);
    // dispatch(createdFolder());
  };

  const handleGobackInputCreate = () => {
    dispatch(scenarioaBack());
  };
  const handleScenarioChange = (e: any) => {
    const { value } = e.target;
    if (value) {
      setNewScenarioValue(value);
    }
  };
  const handleNextClick = () => {
    if (selectFolder) setShowCGOInputForm(true);
    // props?.handleNext();
  };

  const [folderData, setFolderData] = useState<any>([]);
  const getNewFolderData = (data: any) => {
    setFolderData(data);
  };

  const handleGoBack = () => {
    setShowCGOInputForm(false);
  };
  console.log(selectedFolderId, "selectedFolderIdselectedFolderId");
  console.log(props.selectedFolderId, "props.selectedFolderId");
  return (
    <>
      {isFolderCreated && (
        <SelectDataUpload
          isOpen={isFolderCreated}
          inputFolderName={inputFolderName}
        />
      )}
      {isCreateNewFolder &&
      isCreateFolder === true &&
      showCGOInputForm === false ? (
        <CGOCreateFolder
          handleOpenCreateFolder={handleOpenCreateFolder}
          handleCreateNewFolder={handleCreateNewFolder}
          handleGoBack={handleGobackInputCreate}
          handleInputFolderName={handleInputFolderName}
          inputFolderName={inputFolderName}
          handleSelectTimePeriod={handleSelectTimePeriod}
          selectFolderTimePeriod={selectFolderTimePeriod}
          getNewFolderData={getNewFolderData}
        />
      ) : (
        showCGOInputForm === false && (
          <>
            <DialogContent>
              <div className="input-data-pop">
                <FormControl fullWidth>
                  <label className="select-folder-dropdown">
                    Select Folder*
                  </label>
                  <TextField
                    id="select-folder"
                    select
                    required
                    label="Select"
                    variant="outlined"
                    onChange={handleChangeSelectFolder}
                    InputLabelProps={{ shrink: true }}
                    value={selectFolder}
                    defaultValue={selectFolder || ""}
                  >
                    {folderOptions?.map((d: any) => (
                      <MenuItem key={d.id} value={d}>
                        {d.folder}
                      </MenuItem>
                    ))}
                  </TextField>
                </FormControl>
                {selectFolder !== "" && (
                  <FormControl fullWidth style={{ marginTop: "15px" }}>
                    <label className="select-folder-dropdown">
                      Create Scenario*
                    </label>
                    <TextField
                      id="create-scenario"
                      required
                      label="create scenario"
                      variant="outlined"
                      onChange={handleScenarioChange}
                    ></TextField>
                  </FormControl>
                )}
                {selectFolder === "" && (
                  <>
                    <div>
                      <h2 className="hr-lines">
                        <span>Or</span>
                      </h2>
                    </div>
                    <div
                      className="create-new-folder"
                      onClick={handleOpenCreateFolder}
                    >
                      <img src={PlusIcon} alt="" />
                      <h2>Create a new Folder</h2>
                    </div>
                  </>
                )}
              </div>
            </DialogContent>
            <DialogActions>
              <div className="modal-action">
                <Button
                  variant="outlined"
                  className="cancel"
                  onClick={props.handleGoBack}
                >
                  Go Back
                </Button>
                <Button
                  variant="contained"
                  className={
                    selectFolder === "" || newScenarioValue === ""
                      ? "disabled-proc-btn"
                      : "Next"
                  }
                  onClick={(e) => handleNextClick()}
                  // disabled={selectFolder === "" || newScenarioValue === ""}
                >
                  Next
                </Button>
              </div>
            </DialogActions>
          </>
        )
      )}
      {/* this is the page where we upload the no of potential plants and select */}
      {showCGOInputForm && (
        <CGOInputForm
          selectedFolder={selectFolder}
          scenarioValue={newScenarioValue}
          folderData={folderData}
          handleUploadNow={props.handleUploadNow}
          handleClose={props.handleClose}
          handleGoBack={handleGoBack}
          setModalTitleText={props.setModalTitleText}
          selectRadio={props.selectRadio}
          isSelectedScenarios={props.isSelectedScenarios}
          selectedFolderId={selectedFolderId || props.selectedFolderId}
          selectedScenarioId={props.selectedScenarioId}
        />
      )}
    </>
  );
}

export default CGOInputModal;
